/**
 * Tip is also an OpenSeadragon.Overlay but is created from another overlay
 * it shows when parent_overlay:hover triggers or the user taps/clicks the parent_overlay
 */
(function($){ 
    /**
     * Tip class that holds the tip data
     * @param {*} options 
     * @returns 
     */
    $.Tip = function(options) {
        this._options = options;
        this._overlay_data = this._options.overlay_data || {};
        this._parent_overlay = this._options.parent_overlay;
        this._meta = options.meta;

        this._events = {
            hide: 'hide', show: 'show', created: 'created'
        };

        this._canvas_click = this._canvas_click.bind(this);
        this._parent_onclick = this._parent_onclick.bind(this);

        this.viewer = null; 
        
        if (typeof(this._parent_overlay) !== "undefined" && this._parent_overlay.element) {
            this._parent_element = this._parent_overlay.element;
            this._dataset = this._parent_element.dataset;
            this.id = this._overlay_data.tip; 

            this._parent_element.abdo_events.on("clicked", this._parent_onclick);
            this._parent_element.tip = this; // add to parent element 
        }
        this._set_data_attributes();

        // if (!this._is_enabled()) {
        //     return null;
        // }
        
        abdo_osd.overlay._on(abdo_osd.overlay._events.button_clicked, this._goto_button_clicked.bind(this)); 
    };

    $.Tip.prototype = {
        setViewer: function(viewer) {
            if (this.viewer) {
                this.viewer.removeHandler("canvas-click", this._canvas_click);
            }

            this.viewer = viewer;
            this.viewer.addHandler('canvas-click', this._canvas_click);
        },

        _canvas_click: function() { 
            this._hide_others();
        },

        _get_tip_element: function() { 
            if(!this.tip_element) {
                this.tip_element = document.getElementById(this.id);
                if (this.tip_element == null) {
                    this.tip_element = this._create();
                }
            }
            else if (!this.tip_element.parentElement) {
                // create new if detached from DOM
                this.tip_element = this._create();
            }

            return this.tip_element;
        },

        _goto_button_clicked: function(evt, btn, overlay) {
            var overlay_ds = overlay.element.dataset;
            if (typeof(overlay_ds.tip) !== "undefined" && overlay_ds.tip == this.id) {
                this._show();
            }
        }, 

        _set_data_attributes: function() {
            if (typeof(this._overlay_data.tip) !== 'undefined' && this._dataset) {
                this._dataset.tip = this._overlay_data.tip; 
            }

            this._tip_fields = new $.TipFields({
                element: this._parent_element, 
                overlay_data: this._overlay_data,
                meta: this._meta
            });

            // categories
            // if (typeof(this._overlay_data.categories) !== "undefined") {
            //     this._dataset.fields_categories = this._overlay_data.categories; 
            // }
            // if (typeof(this._overlay_data.name) !== "undefined") {
            //     this._dataset['tipTextName'] = this._overlay_data.name;
            // }
        },

        _parent_onclick: function(evt) {
            var tip_element = this._get_tip_element();
            var tip_visible = tip_element != null && !tip_element.classList.contains('d-none');
            if (tip_visible) {
                this._hide();
            }
            else {
                // this._hide_others();
                this._show();
            }
        },

        // _is_enabled: function() {
        //     return ABDOUtil.datasetHasAttributes(this._dataset, ['tip']);
        // },
        
        // ! template generation
        _create: function() {
            var tip_element = this._get_template();
            if (tip_element) {
                tip_element.observer = new MutationObserver(this._class_change_observer.bind(this));
                tip_element.observer.observe(tip_element, {attributes: true});
                
                this._set_data_attributes();
                this._fill_template(tip_element);            
                this._initialize_events(tip_element, this._parent_overlay);
    
                // if (!ABDOUtil.hasTouchScreen) { 
                //     this.parent_element.addEventListener('mouseenter', this._on_mouseenter.bind(this)); 
                //     this.parent_element.addEventListener('mouseleave', this._on_mouseleave.bind(this));
                // }
    
                this.emit(this._events.created, this._overlay_data, tip_element);
                document.body.appendChild(tip_element);
            }

            return tip_element;
        },

        _class_change_observer: function(mutation_list, observer) {
            var i, mutations_n=mutation_list.length;
            var overlay;

            for (i = 0; i <mutations_n; i++) {
                if (mutation_list[i].attributeName === 'class') {  
                    if (mutation_list[i].target.classList.contains('fade-out')) {
                        overlay = this.viewer.getOverlayById(mutation_list[i].target.id);
                        
                        if (overlay) { 
                            this.emit(this._events.hide, overlay);
                        }
                        break;
                    }
                    else if (mutation_list[i].target.classList.contains('fade-in')) {
                        overlay = this.viewer.getOverlayById(mutation_list[i].target.id);
                        
                        if  (overlay) { 
                            this.emit(this._events.show, overlay);
                        }
                        break;
                    } 
                }
            }
        },

        _get_template_selector: function() {
            var tip_selector = '#tip-template'; // default selector
            if (this._dataset && "tipSelector" in this._dataset) {
                tip_selector = this._dataset.tipSelector;
            }

            return tip_selector;
        },

        _get_template: function() {
            var template = document.querySelector(this._get_template_selector());
            if (template) {
                var element = null;
                if (ABDOUtil.isIE) {
                    _IETemplatesPolyfill(); // HTTPリクエストで読み込んだ時にtemplateの昨日を追加
                    // element = template.clone().content.childNodes[0];
                    element = template.cloneNode(true).querySelector("*");
                }
                else {
                    element = document.importNode(template.content, true).querySelector('.tip');
                }

                element.id = this.id;

                return element;
            }

            return null;
        },

        _assign_field_to_element: function(field, datum, element) {
            for(var type in this._field_types) {
                var prefix = this._get_field_prefix(type);

                // if field prefix found
                if (field.indexOf(prefix) >= 0) {
                    switch(type) {
                        case this._field_types.TEXT:
                            element.innerText = datum;
                            break;
                    }
                }
            }
        },

        _fill_template: function(template_element) {
            this._tip_fields.populate(template_element);
        },

        _initialize_events: function(tip_element) {
            var self = this;
            ABDOUtil.preventCanvasPropagation(tip_element);
            
            if (ABDOUtil.supportsAnimation) {
                // アニメーションが終わると非表示
                tip_element.addEventListener('animationend', function(evt){
                    // CSSのアニメーション「fadeOut」が終わると非表示
                    if(evt.animationName == 'fadeOut') {
                        self._finish_hide_tip(tip_element);
                    }
                });
            } 


            var dismiss_tip_elements = tip_element.querySelectorAll('[data-dismiss="tip"]');
            var i, dismiss_tip_element;
            for(i = 0; i < dismiss_tip_elements.length; i++) {
                dismiss_tip_element = dismiss_tip_elements[i];
                
                if (dismiss_tip_element) {
                    ABDOUtil.prepareClickEvent(dismiss_tip_element);
                }
                
                if (ABDOUtil.supportsAnimation) { 
                    if (dismiss_tip_element) {
                        dismiss_tip_element.abdo_events.on("clicked", function(evt){
                            self._hide(this._parent_overlay);
                        });
                        // dismiss_tip_element.addEventListener(ABDOUtil.getClickHandler(dismiss_tip_element), function(evt) { 
                        //     evt.stopImmediatePropagation();
                        //     // CSSアニメーションが発生する
                        //     self._hide(this._parent_overlay);
                        // }); 
                    } 
                }
                else {
                    // アニメーションがなくても非表示が出来るようにする
                    if (dismiss_tip_element) {
                        dismiss_tip_element.abdo_events.on("clicked", function(evt){
                            self._hide(this._parent_overlay); // CSSアニメーションが発生しなくても
                            self._finish_hide(); // 直接に非表示
                        });
                        // dismiss_tip_element.addEventListener(ABDOUtil.getClickHandler(dismiss_tip_element), function(evt) { 
                        //     self._hide(this._parent_overlay); // CSSアニメーションが発生しなくても
                        //     self._finish_hide(); // 直接に非表示
                        // }); 
                    }  
                } 
            } 
        },
    
        // events related

        _finish_hide: function() { 
            this._finish_hide_tip(this._get_tip_element());
        },

        _finish_hide_tip: function(tip_element) {
            ABDOUtil.getViewers().forEach(function(viewer, index) { 
                viewer.removeOverlay(tip_element); 
            });

            ABDOUtil._removeClass(tip_element, 'fade-in');
            tip_element.classList.add('d-none');
            tip_element.style.display = '';
        },

        _hide: function() { 
            this._hide_tip(this._get_tip_element());
        },

        _hide_tip: function(tip_element) {
            ABDOUtil._removeClass(tip_element, 'fade-in');
            tip_element.classList.add('fade-out');
            if (!ABDOUtil.supportsAnimation) {
                this._finish_hide_tip(tip_element);
            }
        },

        _trigger_show: function(tip_element) {
            ABDOUtil._removeClass(tip_element, 'fade-out');
            ABDOUtil._removeClass(tip_element, 'd-none');
            tip_element.classList.add('fade-in');
        },

        _show: function(location) {   
            this._hide_others();

            // prepare location if not available
            if (typeof(location) === 'undefined') {
                var offset_factor = 0.5;

                if (this._parent_overlay) {
                    // transform overlay rect to estimate width and height in viewport coordinates
                    var parent_rect = this._parent_overlay.element.getBoundingClientRect();
                    var parent_location_a = new OpenSeadragon.Point(parent_rect.left,       parent_rect.top);
                    var parent_location_b = new OpenSeadragon.Point(parent_rect.left + parent_rect.width, parent_rect.top + parent_rect.height);
                    var parent_location_vp_a = this.viewer.viewport.pointFromPixel(parent_location_a);
                    var parent_location_vp_b = this.viewer.viewport.pointFromPixel(parent_location_b);
                    var width  = parent_location_vp_b.x - parent_location_vp_a.x;
                    var height = parent_location_vp_b.y - parent_location_vp_a.y;
    
                    // offset overlay by 0.5 of the width and height
                    location = new OpenSeadragon.Point(
                        this._parent_overlay.location.x + width  * offset_factor, 
                        this._parent_overlay.location.y + height * offset_factor);
                }
                else {
                    location = new OpenSeadragon.Point(this._overlay_data.x, this._overlay_data.y);
                }
            } 


            var tip_element = this._get_tip_element();
            if (tip_element) {
                 // add overlay if not added
                // only update (location) if already present
                if (this.viewer.getOverlayById(this.id) == null) { 
                    this.viewer.addOverlay({ 
                        element: tip_element,
                        location: location,
                        rotationMode: OpenSeadragon.OverlayRotationMode.NO_ROTATION
                    });
                }
                else {
                    this.viewer.updateOverlay({
                        element: tip_element,
                        location: location
                    });
                } 

                this._trigger_show(tip_element);
            }
        },

        // // ! Mouse events
        // _on_mouseenter: function(evt) {
        //     var viewer = ABDOUtil.getViewer();
        //     var mouse_bounds_px = {
        //         location: new OpenSeadragon.Point(evt.clientX, evt.clientY),
        //         width: 32,
        //         height: 32
        //     };

        //     var mouse_max_loc_vp = viewer.viewport.pointFromPixel(
        //             mouse_bounds_px.location.plus(new OpenSeadragon.Point(
        //                 mouse_bounds_px.width,mouse_bounds_px.height))
        //     );

        //     var mouse_distance_to_overlay = mouse_max_loc_vp.distanceTo(this._parent_overlay.location);
        //     if (mouse_distance_to_overlay > this._parent_overlay.bounds.width &&
        //         mouse_distance_to_overlay > this._parent_overlay.bounds.height) {
        //             this._show(mouse_max_loc_vp); 
        //     }
        //     else {
        //         this._show(mouse_max_loc_vp);
        //     }
        // },

        // _on_mouseleave: function() {
        //     this._hide();
        // },


        _hide_others: function() { 
            var tips = document.querySelectorAll('div.tip:not(.d-none)');
            for (var index = 0; index < tips.length; index++) { 
                this._hide_tip(tips[index]); 
            } 
        }
    };
    Emitter($.Tip.prototype);

})(ABDOMap);
